import { useQuery } from '@tanstack/react-query';
import { schedulerMonitorApi } from '../api/schedulerMonitorApi';

/**
 * GET /scheduler-monitor/schedules/runs/{id} — 실행 이력 상세 (SCHEDULER_READ)
 * queryKey: ['scheduler-monitor', 'run', id]
 */
export function useScheduleRun(id: number | null) {
  return useQuery({
    queryKey: ['scheduler-monitor', 'run', id],
    queryFn: () => schedulerMonitorApi.getScheduleRun(id!),
    enabled: id !== null,
    staleTime: 60_000,
  });
}
